
(function () {
  'use strict';

  var STORAGE_KEY = 'bt:state:v1';
  var QUERY_PARAM = 'brand';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function rootUrl() {
    var root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.endsWith('/') ? root : root + '/';
  }


  function BrandTakeover(bar) {
    this.bar = bar;
    this.btn = bar.querySelector('[data-bt-toggle]');
    this.main = document.getElementById('MainContent');

    var d = bar.dataset;
    this.suffix = d.suffix || 'brand-takeover';
    this.pageUrl = d.pageUrl || '';
    this.persist = d.persist === 'true';
    this.prefetch = d.prefetch === 'true';
    this.style = 'seam';
    this.brandName = d.brandName || 'Brand';
    this.overlayMark = d.overlayMark || '';
    this.deepLink = d.deepLink === 'true';

    this.defaultFrag = null;
    this.brandHTML = null;
    this.pending = null;
    this.isOn = false;
    this.busy = false;

    this.init();
  }

  BrandTakeover.prototype.init = function () {
    if (!this.btn || !this.main) return;

    this.btn.addEventListener('click', this.onClick.bind(this));

    var params = new URLSearchParams(window.location.search);
    var linked = params.get(QUERY_PARAM);
    var stored = this.persist && this.readStored();

    var wantOn = linked ? linked === 'on' || linked === '1' : stored === true;

    if (wantOn) {
      document.body.classList.add('bt-restoring');
      var self = this;
      this.load()
        .then(function (html) {
          self.captureDefault();
          self.inject(html);
          self.setState(true, { silent: true });
        })
        .catch(function () {
        })
        .then(function () {
          document.body.classList.remove('bt-restoring');
        });
    } else {
      var self2 = this;
      this.idle(function () {
        self2.load().catch(function () {});
        self2.warm();
      });
    }
  };

  BrandTakeover.prototype.warm = function () {
    if (this.warmed) return this.warmed;
    var d = this.bar.dataset;
    var mobile = window.innerWidth < 768;
    var srcs = [(mobile && d.overlayImageMobile) || d.overlayImage || d.overlayImageMobile, d.overlayMark].filter(Boolean);
    this.warmed = Promise.all(srcs.map(function (src) {
      return new Promise(function (resolve) {
        var img = new Image();
        img.onload = img.onerror = function () {
          if (img.decode) img.decode().then(resolve, resolve);
          else resolve();
        };
        img.src = src;
      });
    }));
    return this.warmed;
  };

  BrandTakeover.prototype.ready = function () {
    var cap = new Promise(function (resolve) { setTimeout(resolve, 2500); });
    var both = Promise.all([this.load().catch(function () {}), this.warm()]);
    return Promise.race([both, cap]);
  };

  BrandTakeover.prototype.idle = function (fn) {
    if (window.requestIdleCallback) {
      window.requestIdleCallback(fn, { timeout: 3000 });
    } else {
      setTimeout(fn, 1500);
    }
  };


  BrandTakeover.prototype.readStored = function () {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return false;
      var parsed = JSON.parse(raw);
      return parsed && parsed.on === true && parsed.suffix === (this.pageUrl || this.suffix);
    } catch (e) {
      return false;
    }
  };

  BrandTakeover.prototype.writeStored = function (on) {
    if (!this.persist) return;
    try {
      window.localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ on: on, suffix: (this.pageUrl || this.suffix), at: Date.now() })
      );
    } catch (e) {
    }
  };


  BrandTakeover.prototype.load = function () {
    if (this.brandHTML !== null) return Promise.resolve(this.brandHTML);
    if (this.pending) return this.pending;

    var self = this;
    var url = this.pageUrl && this.pageUrl.charAt(0) === '/'
      ? this.pageUrl
      : rootUrl() + '?view=' + encodeURIComponent(this.suffix);

    this.pending = fetch(url, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'BrandTakeover' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Brand takeover fetch failed: ' + res.status);
        return res.text();
      })
      .then(function (text) {
        self.brandHTML = self.extract(text);
        self.pending = null;
        return self.brandHTML;
      })
      .catch(function (err) {
        self.pending = null;
        throw err;
      });

    return this.pending;
  };

  BrandTakeover.prototype.extract = function (text) {
    if (text.indexOf('<!doctype') === -1 && text.indexOf('<!DOCTYPE') === -1) {
      return text;
    }
    var doc = new DOMParser().parseFromString(text, 'text/html');
    var main = doc.getElementById('MainContent');
    return main ? main.innerHTML : text;
  };


  BrandTakeover.prototype.captureDefault = function () {
    if (this.defaultFrag) return;
    var frag = document.createDocumentFragment();
    while (this.main.firstChild) frag.appendChild(this.main.firstChild);
    this.defaultFrag = frag;
  };

  BrandTakeover.prototype.restoreDefault = function () {
    if (!this.defaultFrag) return false;
    this.main.innerHTML = '';
    this.main.appendChild(this.defaultFrag);
    this.defaultFrag = null;
    if (this.main.querySelector('.flickityt4s:not(.flickityt4s-enabled), .isotopet4s:not(.isotopet4s-enabled)')) {
      this.reinit(this.main, true);
    } else {
      try { if (window.T4SThemeSP && window.T4SThemeSP.Reveal) window.T4SThemeSP.Reveal(this.main); } catch (e) {}
    }
    this.refresh(this.main);
    return true;
  };

  BrandTakeover.prototype.refresh = function (scope) {
    var F = window.Flickityt4s;
    if (F && F.data) {
      Array.prototype.forEach.call(scope.querySelectorAll('.flickityt4s-enabled'), function (el) {
        try { var f = F.data(el); if (f) f.resize(); } catch (e) {}
      });
    }
    try {
      var jq = window.jQuery_T4NT || window.jQuery;
      if (jq) jq(scope).find('.isotopet4s-enabled').each(function () {
        try { jq(this).isotopet4s('layout'); } catch (e) {}
      });
    } catch (e) {}
    try {
      if (window.lazySizes && window.lazySizes.autoSizer) window.lazySizes.autoSizer.checkElems();
    } catch (e) {}
    try { window.dispatchEvent(new Event('resize')); } catch (e) {}
  };

  BrandTakeover.prototype.inject = function (html) {
    this.main.innerHTML = html;
    this.runScripts(this.main);
    this.reinit(this.main);
  };

  BrandTakeover.prototype.runScripts = function (scope) {
    var scripts = scope.querySelectorAll('script');
    for (var i = 0; i < scripts.length; i++) {
      var old = scripts[i];
      var type = (old.getAttribute('type') || '').toLowerCase();
      if (type && type !== 'text/javascript' && type !== 'module' && type.indexOf('javascript') === -1) {
        continue;
      }
      var next = document.createElement('script');
      for (var a = 0; a < old.attributes.length; a++) {
        next.setAttribute(old.attributes[a].name, old.attributes[a].value);
      }
      next.textContent = old.textContent;
      old.parentNode.replaceChild(next, old);
    }
  };

  BrandTakeover.prototype.reinit = function (scope) {
    var T = window.T4SThemeSP;

    if (T) {
      [
        'fullHeightFirtSe',
        'initVarHeight',
        'initMarquee3k',
        'initMarquee',
        'initCarousel',
        'announcement',
        'T4SWrappTable',
        'AccordionMobileInt',
        'getScrollbar'
      ].forEach(function (name) {
        try {
          if (typeof T[name] === 'function') T[name]();
        } catch (e) {}
      });

      try {
        if (T.Isotopet4s && typeof T.Isotopet4s.initEach === 'function') {
          T.Isotopet4s.initEach();
        }
      } catch (e) {}

      try {
        if (typeof T.Reveal === 'function') T.Reveal(scope, true);
      } catch (e) {}
    }

    var sections = scope.querySelectorAll('[id^="shopify-section-"]');
    for (var i = 0; i < sections.length; i++) {
      var el = sections[i];
      var id = el.id.replace('shopify-section-', '');
      var evt = new CustomEvent('shopify:section:load', {
        bubbles: true,
        detail: { sectionId: id, load: true }
      });
      el.dispatchEvent(evt);
    }

    try {
      if (window.lazySizes && window.lazySizes.autoSizer) {
        window.lazySizes.autoSizer.checkElems();
      }
    } catch (e) {}

    document.dispatchEvent(
      new CustomEvent('brandtakeover:swapped', {
        detail: { on: this.isOn, suffix: this.suffix }
      })
    );
  };

  BrandTakeover.prototype.sweep = function () {
    if (prefersReducedMotion() || !window.BTFX) {
      return { covered: Promise.resolve(), done: Promise.resolve() };
    }
    return window.BTFX.run(this) || { covered: Promise.resolve(), done: Promise.resolve() };
  };

  BrandTakeover.prototype.wait = function (ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms);
    });
  };


  BrandTakeover.prototype.onClick = function (e) {
    e.preventDefault();
    if (this.busy) return;
    this.toggle(!this.isOn);
  };

  BrandTakeover.prototype.toggle = function (on) {
    var self = this;
    this.busy = true;
    this.btn.setAttribute('aria-busy', 'true');
    var pre = on && (this.brandHTML === null || !this.warmed) ? this.ready() : Promise.resolve();
    pre.then(function () { self.run(on); });
  };

  BrandTakeover.prototype.run = function (on) {
    var self = this;
    var work = on ? this.load() : Promise.resolve(null);

    var pass;
    try {
      pass = this.sweep();
    } catch (err) {
      if (window.console) console.warn('[brand-takeover] overlay failed', err);
      pass = { covered: Promise.resolve(), done: Promise.resolve() };
    }

    Promise.all([pass.covered, work])
      .then(function (results) {
        if (on) {
          self.captureDefault();
          self.inject(results[1]);
        } else {
          self.restoreDefault();
        }
        window.scrollTo({ top: 0, behavior: 'auto' });
        self.setState(on);
      })
      .catch(function (err) {
        if (window.console) console.warn('[brand-takeover]', err);
      })
      .then(function () {
        if (pass.release) pass.release();
      })
      .then(function () {
        return pass.done;
      })
      .then(function () {
        self.busy = false;
        self.btn.setAttribute('aria-busy', 'false');
      });
  };

  BrandTakeover.prototype.setState = function (on, opts) {
    opts = opts || {};
    this.isOn = on;

    this.btn.setAttribute('aria-checked', on ? 'true' : 'false');
    this.bar.classList.toggle('bt-bar--on', on);
    document.body.classList.toggle('brand-takeover-on', on);

    this.main.classList.remove('bt-swapping');

    this.writeStored(on);

    var url = new URL(window.location.href);
    if (on) {
      url.searchParams.set(QUERY_PARAM, 'on');
    } else {
      url.searchParams.delete(QUERY_PARAM);
    }
    try { window.history.replaceState({ bt: on ? 1 : 0 }, '', url.toString()); } catch (err) {}

    if (!opts.silent) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'brand_takeover_toggle',
        brand_takeover_state: on ? 'on' : 'off',
        brand_takeover_brand: this.brandName
      });
    }
  };


  function boot() {
    var bars = document.querySelectorAll('.bt-bar[data-bt-bar]');
    for (var i = 0; i < bars.length; i++) {
      if (bars[i].dataset.btReady === 'true') continue;
      bars[i].dataset.btReady = 'true';
      new BrandTakeover(bars[i]);
    }
  }

  ready(boot);

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.bt-bar')) {
      boot();
    }
  });
})();
